import { TeleprompterInterface, TeleprompterSectionInterface, TeleprompterSearchInterface } from '../types/interfaces';
import { getAuthenticatedRequestInit } from './utils';

export const LoadTeleprompters = (
	token: string,
	searchParams: TeleprompterSearchInterface,
): Promise<TeleprompterInterface[]> => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/teleprompters/load`, {
	method: 'POST',
	body: JSON.stringify({
		meeting: searchParams.meeting,
		gr_user: searchParams.gr_user,
	}),
	...getAuthenticatedRequestInit(token),
}).then(async (result) => {
	if (result.ok) {
		return result.json();
	}
	throw new Error('load teleprompters error');
});

export const LoadTeleprompter = (
	token: string,
	teleprompterId: number,
): Promise<TeleprompterInterface> => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/teleprompters/${teleprompterId}`, {
	method: 'GET',
	...getAuthenticatedRequestInit(token),
}).then((result) => {
	if (result.ok) {
		return result.json();
	}
	throw new Error('get teleprompter with error');
});

export const CreateTeleprompter = (
	token: string,
	teleprompter: TeleprompterInterface,
): Promise<TeleprompterInterface> => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/teleprompters`, {
	method: 'POST',
	body: JSON.stringify(teleprompter),
	...getAuthenticatedRequestInit(token),
}).then((result) => {
	if (result.ok) {
		return result.json();
	}
	throw new Error('create teleprompter error');
});

export const EditTeleprompter = (
	token: string,
	teleprompter: TeleprompterInterface,
): Promise<Boolean> => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/teleprompters/${teleprompter.id}`, {
	method: 'PUT',
	body: JSON.stringify(teleprompter),
	...getAuthenticatedRequestInit(token),
}).then((result) => {
	if (result.ok) {
		return true;
	}
	throw new Error('edit teleprompter error');
});

export const GetTeleprompterSharedWith = (
	token: string,
	teleprompterId: number,
): Promise<number[]> => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/teleprompters/${teleprompterId}/share`, {
	method: 'GET',
	...getAuthenticatedRequestInit(token),
}).then((result) => {
	if (result.ok) {
		return result.json();
	}
	throw new Error('get teleprompter share with error');
});

/**
 * Share teleprompter with users
 *
 * @param   {number}    teleprompterId  id of teleprompter to share
 * @param   {number[]}  [shareWithIds]  array of gr_user to share teleprompter with
 *
 */
export const ShareTeleprompter = (
	token: string,
	teleprompterId: number,
	shareWithIds: number[],
): Promise<Boolean> => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/teleprompters/${teleprompterId}/share`, {
	method: 'POST',
	body: JSON.stringify(shareWithIds),
	...getAuthenticatedRequestInit(token),
}).then((result) => {
	if (result.ok) {
		return true;
	}
	throw new Error('share teleprompter error');
});

export const CreateTeleprompterSection = (
	token: string,
	teleprompterId: number,
	section: TeleprompterSectionInterface,
): Promise<TeleprompterSectionInterface> => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/teleprompters/${teleprompterId}/sections`, {
	method: 'POST',
	body: JSON.stringify(section),
	...getAuthenticatedRequestInit(token),
}).then((result) => {
	if (result.ok) {
		return result.json();
	}
	throw new Error('create teleprompter sections error');
});

export const EditTeleprompterSection = (
	token: string,
	teleprompterId: number,
	section: TeleprompterSectionInterface,
): Promise<Boolean> => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/teleprompters/${teleprompterId}/sections`, {
	method: 'PUT',
	body: JSON.stringify(section),
	...getAuthenticatedRequestInit(token),
}).then((result) => {
	if (result.ok) {
		return true;
	}
	throw new Error('edit teleprompter sections error');
});
